<template>
  <div>
    <div class="menu">
      <div class="logo">
        <LogoIcon />
        <span>ARTISTHUB</span>
      </div>
      <div class="menu-items">
        <div class="menu-left">
          <div class="menu-item" v-for="(menu, index) in leftMenu" :key="index">
            <router-link :to="menu.routeName">
              <span>{{ menu.linkName }}</span>
            </router-link>
          </div>
        </div>
        <div class="menu-right">
          <div class="menu-item">
            <a href="http://help.artisthub.io/"><span>Help</span></a>
          </div>
          <div
            class="menu-item"
            v-for="(menu, index) in rightMenu"
            :key="index"
          >
            <router-link :class="menu.class" :to="{ name: menu.routeName }">
              <span>{{ menu.linkName }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <section class="blog" v-if="post === 'not-found'">
      <h1>Blog Post Not Found</h1>
    </section>
    <section class="blog" v-else-if="post">
      <div class="back">
        <router-link to="/blog">
          <i class="fa-light fa-arrow-left-long"></i>
          <span>Back to Blog</span>
        </router-link>
      </div>
      <div class="top">
        <div class="category">{{ post.category && post.category.name }}</div>
        <div class="date">{{ post.created_at | formatDate }}</div>
      </div>
      <h1 class="title">{{ post.title }}</h1>
      <h3 class="description">{{ post.description }}</h3>
      <div v-html="post.content"></div>
    </section>
    <div v-else>
      Loading...
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { GET_POST_BY_SLUG } from "@/graphql";
import LogoIcon from "@/components/AppLogo";

export default {
  components: {
    LogoIcon
  },
  data() {
    return {
      post: {},
      leftMenu: [
        {
          routeName: "#pricing",
          linkName: "Pricing"
        }
      ],
      rightMenu: [
        {
          routeName: "Login",
          class: "",
          linkName: "Log In"
        },
        {
          routeName: "Signup",
          class: "button-default big",
          linkName: "Sign Up"
        }
      ]
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format("dddd, MMMM Do YYYY");
    }
  },
  apollo: {
    blog_posts: {
      client: "httpClient",
      query: GET_POST_BY_SLUG,
      variables() {
        return {
          slug: this.$route.params.slug
        };
      },
      result({ data }) {
        try {
          this.post = data.blog_posts[0];
        } catch (e) {
          this.post = "not-found";
        }
      }
    }
  }
};
</script>

<style lang="scss">
.menu {
  padding: 30px;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  z-index: 1;

  .logo {
    display: flex;
    align-items: center;
    img {
      width: 33px;
      path {
        fill: white;
      }

      display: none;
    }
    span {
      margin-left: 13px;
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 21px;
      line-height: 39px;
      text-transform: uppercase;
      color: white;
    }
  }
  .menu-items {
    margin-left: 60px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 60px;
  }
  .menu-left,
  .menu-right {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 40px;
    align-items: center;
    .menu-item {
      display: flex;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: white;
      a {
        color: inherit;
        text-decoration: none;
      }
    }
  }
}
section.blog {
  padding: 30px 100px;
  .back {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    a {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: $text-type-2;
      text-decoration: none;
      i {
        margin-right: 10px;
      }
    }
  }
  .top {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    .category {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: $text-type-2;
      background-color: rgba(128, 0, 128, 0.956);
      padding: 5px 10px;
      border-radius: 25px;
      margin-right: 10px;
    }
    .date {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: $text-type-2;
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  img,
  blockquote {
    margin-bottom: 30px;
    color: $text-type-2;
  }
  .title {
    font-weight: bold;
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 40px;
  }
  .description {
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 50px;
  }
  p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
  img {
    width: 100%;
  }
  li {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 10px;
  }
  a {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-decoration: none;
    &:hover {
      color: $text-type-1;
    }
  }
}
</style>
